import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { CastLooksProps } from "./CastLooks";
const CastLooks = lazy(() => import("./CastLooks").then(module => ({ default: module.CastLooks })));

export function mountCastLooks(slot: HTMLElement, props: CastLooksProps) {
  setStudioView("stage", `cast-looks:${props.projectId}`, <CastLooks key={props.projectId} {...props} />);
}
